import { createContext, useContext, useMemo, useState } from 'react';
import { lloydConstants } from '../Constants';

export const defaultSelectionValues = {
	country: [],
	setCountry: () => {},
	incomeLevel: [],
	setIncomeLevel: () => {},
	colorBy: lloydConstants.colorBy['1'],
	setColorBy: () => {},
	colourBlindSafe: false,
	setColourBlindSafe: () => {},
	isEmpty: true,
};

const SelectionContext = createContext(defaultSelectionValues);

export const SelectionProvider = ({ children }) => {
	const [country, setCountry] = useState(defaultSelectionValues.country);
	const [incomeLevel, setIncomeLevel] = useState(defaultSelectionValues.incomeLevel);
	const [colorBy, setColorBy] = useState(defaultSelectionValues.colorBy);
	const [colourBlindSafe, setColourBlindSafe] = useState(defaultSelectionValues.colourBlindSafe);

	const isEmpty = useMemo(() => {
		let isEmpty = true;
		for (const value of [country, incomeLevel, colorBy]) {
			if (Array.isArray(value)) {
				if (value.length > 0) {
					isEmpty = false;
					break;
				}
			}

			if ((typeof value === 'string' || value instanceof String) && value !== defaultSelectionValues.colorBy) {
				isEmpty = false;
				break;
			}
		}

		return isEmpty;
	}, [country, incomeLevel, colorBy]);

	const value = useMemo(
		() => ({ country, setCountry, incomeLevel, setIncomeLevel, colorBy, setColorBy, colourBlindSafe, setColourBlindSafe, isEmpty }),
		// Stable identity: the chart's draw effect depends on this object, and a new
		// one every render would rebind and re-transition every shape.
		[country, setCountry, incomeLevel, setIncomeLevel, colorBy, setColorBy, colourBlindSafe, setColourBlindSafe, isEmpty]
	);

	return <SelectionContext.Provider value={value}>{children}</SelectionContext.Provider>;
};

export const useSelectionContext = () => useContext(SelectionContext);
